<template>
  <div class="ow-header" :class="headerClass">
    <div class="ow-header-content">
      <router-link :to="'/'" tag="div" class="ow-header-logo">
        <div class="logo"></div>
      </router-link>
      <ul class="ow-header-main">
        <li class="ow-header-item">
          <router-link :to="'/'">{{ $t("home") }}</router-link>
        </li>
        <li class="ow-header-item">
          <router-link :to="'/core-competence'">{{ $t("hxys") }}</router-link>
          <div class="ow-header-item-menu">
            <div>
              <router-link :to="'/core-competence#CORE-TECHNOLOGIES'"
                >核心技术</router-link
              >
            </div>
            <div>
              <router-link :to="'/core-competence#CORE-COMPETENCE'"
                >核心能力</router-link
              >
            </div>
            <div>
              <router-link :to="'/core-competence#DATA-CENTER'"
                >数据中台</router-link
              >
            </div>
          </div>
        </li>
        <li class="ow-header-item">
          <router-link :to="'/solution'">{{ $t("jjfa") }}</router-link>
          <div class="ow-header-item-menu">
            <div>
              <div>
                <router-link :to="'/solution?tab=0#TAB-CONTENT'"
                  >市域治理</router-link
                >
              </div>
              <router-link :to="'/solution?tab=1#TAB-CONTENT'"
                >智慧社区</router-link
              >
            </div>
            <div>
              <router-link :to="'/solution?tab=2#TAB-CONTENT'"
                >智慧园区</router-link
              >
            </div>
            <div>
              <router-link :to="'/solution?tab=3#TAB-CONTENT'"
                >智慧校园</router-link
              >
            </div>
          </div>
        </li>
        <li class="ow-header-item">
          <router-link :to="'/product-service'">{{ $t("cpfw") }}</router-link>
          <div class="ow-header-item-menu">
            <div>
              <router-link :to="'/product-service#DATA-FEEL'"
                >数据感知</router-link
              >
            </div>
            <div>
              <router-link :to="'/product-service#DATA-ANALYSIC'"
                >数据分析</router-link
              >
            </div>
            <div>
              <router-link :to="'/product-service#DATA-SERVICE'"
                >数据服务</router-link
              >
            </div>
          </div>
        </li>
        <li class="ow-header-item">
          <router-link :to="'/news-center'">{{ $t("xwzx") }}</router-link>
          <div class="ow-header-item-menu">
            <div>
              <router-link :to="'/news-center#ACTIVITY'">行业活动</router-link>
            </div>
            <div>
              <router-link :to="'/news-center#OFFICIAL-RELEASE'"
                >媒体报道</router-link
              >
            </div>
            <div>
              <router-link :to="'/news-center#OFFICIAL-RELEASE'"
                >官方发布</router-link
              >
            </div>
          </div>
        </li>
        <li class="ow-header-item">
          <router-link :to="'/about-us'">{{ $t("gywm") }}</router-link>
          <div class="ow-header-item-menu">
            <div>
              <router-link :to="'/about-us#COMPANY-INTROATION'"
                >公司介绍</router-link
              >
            </div>
            <div>
              <router-link :to="'/about-us#DEVELOP-PROGRESS'"
                >发展历程</router-link
              >
            </div>
            <div>
              <router-link :to="'/about-us#PROJECT-GET'">项目落地</router-link>
            </div>
            <div>
              <router-link :to="'/about-us#HONOR'">荣誉资质</router-link>
            </div>
          </div>
        </li>
        <li class="ow-header-item">
          <router-link :to="'/join-us'">{{ $t("jrwm") }}</router-link>
          <div class="ow-header-item-menu">
            <div>
              <router-link :to="'/join-us#RECRUITMENT-POSITION'"
                >招聘岗位</router-link
              >
            </div>
            <div>
              <router-link :to="'/join-us#WELFARE'">福利待遇</router-link>
            </div>
            <div>
              <router-link :to="'/join-us#TEAM-BUILDING'">团队建设</router-link>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "ow-header",
  data() {
    return {
      headerClassSet: new Set(),
      headerClass: "",
      oldTop:
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop
    };
  },
  watch: {
    "$route.fullPath": {
      immediate: true,
      handler(val) {
        if (val === "/") {
          this.headerClassSet.add("transparent");
          this.headerClassSet.delete("light");
          this.headerClassSet.delete("dark");
          this.headerClass = [...this.headerClassSet];
        } else {
          this.headerClassSet.add("dark");
          this.headerClassSet.delete("light");
          this.headerClassSet.delete("transparent");
          this.headerClass = [...this.headerClassSet];
        }
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.scrollHandler);
  },
  methods: {
    scrollHandler() {
      const top =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      let dom = document.getElementById("videoBanner");
      if (dom) {
        if (top >= dom.offsetHeight) {
          this.headerClassSet.add("dark");
        } else {
          this.headerClassSet.delete("dark");
        }
        this.headerClass = [...this.headerClassSet];
      } else {
        /* if (top >= 100) {
          this.headerClassSet.add("hide");
        } else {
          this.headerClassSet.delete("hide");
        }
        this.headerClass = [...this.headerClassSet]; */
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollHandler);
  }
};
</script>
<style lang="less">
.ow-header {
  position: fixed;
  height: 4.8rem;
  // background-color: #1a1a1a;
  display: block;
  width: 100%;
  z-index: 999;
  left: 0;
  top: 0;
  transition: all 0.2s linear;
  &.light {
    background: #ffffff;
  }
  &.transparent {
    background: 0 0;
    .ow-header-logo {
      background-image: url("~@/assets/images/nav/logo_w.png");
    }
    .ow-header-main {
      .ow-header-item {
        > a {
          color: #ffffff;
        }
        &:hover {
          > a {
            color: #2f61ae;
          }
        }
      }
    }
    &:hover {
      background: #030f21;
    }
    + div {
      .banner {
        margin-top: -4.8rem;
      }
    }
  }
  &.dark {
    background: #030f21;
    .ow-header-content {
      .ow-header-logo {
        background-image: url("~@/assets/images/nav/logo_w.png");
      }
      .ow-header-main {
        .ow-header-item {
          > a {
            color: #ffffff;
          }
          &:hover {
            > a {
              color: #2f61ae;
            }
          }
        }
      }
    }
  }
  &.color {
    background: rgba(26, 26, 26, 0.7);
  }
  &.hide {
    margin-top: -4.8rem;
  }
}

.ow-header-content {
  display: flex;
  justify-content: center;
  height: 4.8rem;
  margin: 0px auto;
  position: relative;
  z-index: 2;
}
.ow-header-logo {
  display: block;
  margin-top: 0.85rem;
  width: 3.65rem;
  height: 3rem;
  background-image: url("~@/assets/images/nav/logo.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  > img {
    width: 100%;
  }
}
.ow-header-item {
  float: left;
  width: 8rem;
  height: 4.8rem;
  position: relative;
  .ow-header-item-menu {
    display: none;
    position: absolute;
    left: 50%;
    top: 100%;
    width: 8rem;
    font-size: 0.67rem;
    text-align: center;
    line-height: 2rem;
    background-color: #ffffff;
    transform: translate(-50%);
    a {
      display: block;
      font-size: 0.9rem;
      color: #333333;
      line-height: 3;
      &:hover {
        color: #2f61ae;
      }
    }
  }
  &:hover {
    > a {
      color: #2f61ae;
    }
    > a:after {
      transform: scale(1, 1) translateX(-50%);
      opacity: 1;
    }
    .ow-header-item-menu {
      display: block;
    }
  }
  > a {
    display: block;
    height: 4.8rem;
    line-height: 4.8rem;
    font-size: 1rem;
    color: #333333;
    font-weight: bold;
    opacity: 0.95;
    transition: color 0.3s linear;
    text-align: center;
    position: relative;
    z-index: 2;
    &:hover {
      color: #2f61ae;
    }
    &:after {
      display: block;
      content: "";
      height: 0.2rem;
      width: 75%;
      position: absolute;
      bottom: 0;
      left: 50%;
      background: #2f61ae;
      opacity: 0;
      transition: transform 0.2s ease-out, opacity 0.2s ease-out;
      transform-origin: 25% 0;
      transform: scale(0.01, 1) translateX(-50%);
    }
  }
}
.ow-header-main {
  display: block;
  cursor: pointer;
  opacity: 1;
  transition: opacity 0.3s linear;
  transform: translate(0px, 0);
}
@media screen and (max-width: 1900px) {
  .ow-header-content {
    width: 96%;
  }
  .ow-header-item {
    margin-left: 2rem;
  }
  .ow-header-main {
    right: 5rem;
  }
}
@media screen and (max-width: 800px) {
  .ow-header-main {
    right: 0;
  }
}
</style>
